import { Tabs } from 'components/tabs';

import PlaylistVideosList from '../playlist-videos';
import RelatedVideosList from './RelatedVideosList';
import SidebarVideosProps from './SidebarVideos.props';

import { useState } from 'react';
import { TalkPageAds } from '../../../../ads';
import { useTalkPageContext } from '../talk-page-context';

const SidebarVideos = ({ id }: SidebarVideosProps) => {
  const { playlistSlug } = useTalkPageContext();

  enum tabIndices {
    WatchNext = 0,
    Playlist = 1
  }

  const initialIndex = playlistSlug
    ? tabIndices.Playlist
    : tabIndices.WatchNext;

  const [selectedIndex, setSelectedIndex] = useState(initialIndex);

  const tabItems = [
    {
      title: 'Watch next',
      content: (
        <div className="pt-6">
          <RelatedVideosList id={id} />
        </div>
      )
    },
    ...(playlistSlug
      ? [
          {
            title: 'Playlist',
            content: (
              <div className="pt-6">
                <PlaylistVideosList slug={playlistSlug} talkID={id} />
              </div>
            )
          }
        ]
      : [])
  ];

  return (
    <div>
      <Tabs
        items={tabItems}
        selectedIndex={selectedIndex}
        onChange={setSelectedIndex}
      />
      <TalkPageAds.TalkAdSideBarBTF />
    </div>
  );
};

export default SidebarVideos;
